import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { getServerUri } from "../modules/uriUtility";

/**
 * A standing reminder that the dashboard is showing someone else's company.
 *
 * Without it the only difference between working in your own company and
 * working in a client's is a dropdown value, and every version created, asset
 * uploaded and playable exported lands in whichever one is selected. The banner
 * is deliberately hard to miss and offers the way back.
 */

const useStyles = makeStyles(() => ({
  banner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    padding: "4px 12px",
    backgroundColor: "#FBC02D",
    color: "#3E2723",
    fontSize: "0.8rem",
    fontWeight: 600,
    letterSpacing: "0.02em",
  },
  button: {
    border: "1px solid #3E2723",
    borderRadius: "3px",
    background: "transparent",
    color: "inherit",
    font: "inherit",
    fontSize: "0.75rem",
    padding: "1px 8px",
    cursor: "pointer",
  },
}));

export default function BannerSwitchedCompany(props) {
  const classes = useStyles();

  if (!props.isSwitchedCompany) {
    return null;
  }

  const goHome = () => {
    const homeCompanyID = localStorage.getItem("user.homeCompanyID");
    if (!homeCompanyID) {
      return;
    }
    fetch(getServerUri("company/switch"), {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        companyID: homeCompanyID,
      }),
    })
      .then(() => {
        localStorage.removeItem("selectedGameID");
        localStorage.removeItem("selectedBaseID");
        localStorage.removeItem("selectedVersionID");
        window.location.reload();
      })
      .catch(() => {
        if (props.createSnackbar) {
          props.createSnackbar("Could not return to your own company.", "error", false);
        }
      });
  };

  return (
    <div id="bannerSwitchedCompany" className={classes.banner}>
      <span>
        Viewing {props.companyName || "another company"} — anything you create or export is saved there.
      </span>
      <button type="button" className={classes.button} onClick={goHome}>
        Back to my company
      </button>
    </div>
  );
}
